module.exports = __webpack_public_path__ + "static/media/057-le quartier General.5dd9836b.jpg";